// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center[data-v-189bf3f9]{display:flex;width:100%;min-height:100vh;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
